/**
 * WordPress Contact Forms 7 plugin js overrides
 *
 * This is sorta hacked together to meet budget and design
 * requirements 😬
 */

// customize select boxes
document.querySelectorAll('.wpcf7-form select')?.forEach((el) => {
	const blank = el.querySelector('option:first-child');
	if (blank && blank.textContent === '—Please choose an option—') {
		// change name of empty selections
		blank.textContent = 'Subject';
		// disable it
		blank.disabled = true;
		// have placeholder-like state at first
		el.classList.add('pre-select');
		el.addEventListener('change', () => {
			el.classList.remove('pre-select');
		});
	}
});

// customize file entry fields
document.querySelectorAll('.wpcf7-aquamin-file')?.forEach((el) => {
	const titleEl = el.querySelector('.button');
	const title = titleEl.textContent;
	const file = el.querySelector('[type="file"]');
	el.addEventListener('change', () => {
		const fileName = file?.files?.[0]?.name;
		titleEl.textContent = fileName ? `${title}: ${fileName}` : title;
	});
});
